import { UseMutateFunction, useMutation, UseMutationOptions } from "@tanstack/react-query";
import { DeleteCardResponseDTO } from "../../response.types";

import { savedShipmentService } from "../../api";

type UseAirDeleteCardMutationReturnType = {
  isCardDeleted: boolean | undefined;
  deleteCard: UseMutateFunction<DeleteCardResponseDTO, Error, number>;
  isCardDeleteSuccess: boolean;
  isCardDeleteError: boolean;
  isCardDeleting: boolean;
};

export const useAirDeleteCardMutation = (
  mutationOptions?: UseMutationOptions<DeleteCardResponseDTO, Error, number>
): UseAirDeleteCardMutationReturnType => {
  const { data, mutate, isError, isPending, isSuccess } = useMutation<DeleteCardResponseDTO, Error, number>({
    mutationFn: savedShipmentService.deleteCard,
    ...mutationOptions,
  });

  return {
    isCardDeleted: data?.deleted,
    deleteCard: mutate,
    isCardDeleteSuccess: isSuccess,
    isCardDeleteError: isError,
    isCardDeleting: isPending,
  };
};
